import styles from "./MainTitle.module.scss";
import React from "react";

interface MainTitleProps {
  text: string;
  subtitleText?: string;
  titleSize?: number;
}

const MainTitle: React.FC<MainTitleProps> = ({ text, subtitleText, titleSize = 30 }) => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title} style={{ fontSize: titleSize + "px" }}>
        {text}
      </h2>
      {subtitleText && <p className={styles.subtitle}>{subtitleText}</p>}
    </div>
  );
};

export default MainTitle;
